import styled from "styled-components"

const BreakdownRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 50px;
`

const BreakdownItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const BreakdownValue = styled.div`
  font-size: 28px;
  font-weight: 600;
  color: #0f172a;
`

const BreakdownLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: var(--Neutral-500, #64748b);
`

interface VersionBreakdownProps {
  v1: number
  v2: number
}

export const VersionBreakdown = ({ v1, v2 }: VersionBreakdownProps) => (
  <BreakdownRow>
    <BreakdownItem>
      <BreakdownValue>{v1.toLocaleString()}</BreakdownValue>
      <BreakdownLabel>Nuve V1</BreakdownLabel>
    </BreakdownItem>
    <BreakdownItem>
      <BreakdownValue>{v2.toLocaleString()}</BreakdownValue>
      <BreakdownLabel>Nuve V2</BreakdownLabel>
    </BreakdownItem>
  </BreakdownRow>
)
